<template>
  <el-dialog :visible.sync="dialogVisible" class="job-requirement-dialog" :close-on-click-modal="false" append-to-body width="80vw">
    <div slot="title" class="dialog-title">
      <!-- TODO:tooltip加在哪 -->
      标签归类<span style="color:#F56C6C">（请给选择的标签归类，哪些是必须符合项，哪些是优先符合项）</span>
    </div>

    <div class="tag-type-content">
      <div v-for="item in result" :key="`tagClassify${item.label}${item.tag}`" class="tag-type-item">
        <span class="flex-none mr10" style="min-width:70px;word-break:keep-all;">{{ item.label }}：</span>
        <div class="mr10" style="min-width:110px">
          <el-tag size="small">{{ item.tag }}</el-tag>
        </div>
        <el-radio-group v-model="item.type">
          <el-radio label="必须">必须</el-radio>
          <el-radio label="优先">优先</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- <div class="tag-type-requirement-content">
      <div v-for="item in requirementResult" :key="`tagClassify${item.label}${item.tag}`" class="tag-type-item">
        <el-radio-group v-model="item.type" class="flex-none mr10">
          <el-radio label="必须">必须</el-radio>
          <el-radio label="优先">优先</el-radio>
        </el-radio-group>
        <p>{{ item.tag }}</p>
      </div>
    </div> -->

    <span slot="footer" class="dialog-footer" style="display:flex;justify-content: center;">
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { tags } from '../../constant/type'
import { defaultProject } from '../../constant/defaultData'

export default {
  data() {
    return {
      dialogVisible: false,
      project: window._.cloneDeep(defaultProject),
      fieldMap: {
        性别: '性别',
        婚育: '婚育',
        倾向年龄: '年龄要求',
        地域: '地域',
        学历要求: '学历要求',
        倾向学历: '倾向学历',
        职能模块: '职能模块',
        细分职能: '细分职能',
        擅长方向: '擅长方向',
        投资风格: '投资风格',
        职业资格: '标签',
        目标行业: '目标行业',
        平台: '平台',
        业绩: '业绩',
        工作年限: '工作年限',
        职级: '职级',
        管理职级: '管理职级',
        专业职级: '专业职级',
        语言能力: '标签',
        专业能力: '标签',
        领导能力: '标签',
        个人风格: '标签',
        '心态/性格': '标签',
        // 补充要求: '核心要求',
      },
      result: [],
      // requirementResult: [],
      tagsLabelTranslate:{
        领导能力:'领导',
        个人风格:'个人风格',
        '心态、个性':'心态/性格',
        语言能力:'语言能力',
        专业能力:'专业因素',
      },
    }
  },
  mounted() {
    const obj = {}
    tags.forEach(tag => {
      obj[tag.label === '心态、个性' ? '心态/性格' : tag.label] = tag.children
    })
    this.tags = obj
  },
  methods: {
    open(project) {
      const { tags: projectTags, fieldMap, checkValue,tagsLabelTranslate } = this
      const copyProject = window._.cloneDeep(project)
      const oldValue = copyProject.标签分类

      const result = []

      for (const label in fieldMap) {

        const field = fieldMap[label]
        const value = copyProject[field]
        if (!value) continue
        if (Array.isArray(value) && value.filter(a => a).length === 0) continue

        if (field === '标签') {
          const arr = projectTags[tagsLabelTranslate[label] || label] || []
          const resArr = value.filter(v => arr.includes(v))
          resArr.forEach(a => {
            const obj = { label: label, tag: a }
            obj.type = checkValue(oldValue, obj)
            result.push(obj)
          })
        } else if (field === '年龄要求') {
          const obj = { label: label, tag: `${value[0]}--${value[1]}` }
          obj.type = checkValue(oldValue, obj)
          result.push(obj)
        } else if (Array.isArray(value)) {
          value.forEach(a => {
            const obj = { label: label, tag: a }
            obj.type = checkValue(oldValue, obj)
            result.push(obj)
          })
        } else {
          const obj = { label: label, tag: value }
          obj.type = checkValue(oldValue, obj)
          result.push(obj)
        }
      }
      this.result = result
      // const requirement = (copyProject['核心要求'] || []).filter(v => v)
      // this.requirementResult = requirement.map(v => {
      //   const obj = { label: '核心要求', tag: v }
      //   obj.type = checkValue(oldValue, obj)
      //   return obj
      // })

      this.dialogVisible = true
    },
    checkValue(oldValue = {}, item) {
      const bixu = oldValue.必须 || []
      const bixuHas = bixu.find(v => v.label === item.label && v.tag === item.tag)
      if (bixuHas) return '必须'
      const youxian = oldValue.优先 || []
      const youxianHas = youxian.find(v => v.label === item.label && v.tag === item.tag)
      if (youxianHas) return '优先'
      return ''
    },
    confirm() {
      const { result, requirementResult } = this
      const res = {}
      const bixu = []
      const youxian = []
      const qita = []
      result.forEach(v => {
        if (v.type === '必须') bixu.push(v)
        else if (v.type === '优先') youxian.push(v)
        else qita.push(v)
      })
      // requirementResult.forEach(v => {
      //   if (v.type === '必须') bixu.push(v)
      //   else if (v.type === '优先') youxian.push(v)
      //   else qita.push(v)
      // })
      res.必须 = bixu
      res.优先 = youxian
      res.其他 = qita
      this.$emit('confirm', res)

      this.dialogVisible = false
    },
  },
}
</script>
<style>
.job-requirement-dialog .el-dialog__body {
  padding-top: 0px;
}
.requirement-content-item .el-input-group__append {
  padding-left: 5px;
  padding-right: 5px;
}
</style>
<style scoped>
.dialog-title {
  font-size: 16px;
  text-align: left;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 8px;
}
.tag-type-content {
  display: flex;
  flex-wrap: wrap;
}
.tag-type-content .tag-type-item {
  min-width: 360px;
  display: flex;
  margin-bottom: 10px;
  margin-right: 15px;
  align-items: center;
}
.tag-type-requirement-content .tag-type-item {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.flex {
  display: flex;
}
.flex-none {
  flex: none;
}
.align-center {
  align-items: center;
}
</style>
